import { render, staticRenderFns } from "./cq-player-stats.vue?vue&type=template&id=0662f97c&scoped=true&"
import script from "./cq-player-stats.vue?vue&type=script&lang=js&"
export * from "./cq-player-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662f97c",
  null
  
)

export default component.exports